import { ChakraProvider } from '@chakra-ui/react'

import store from '@core/app/store/store'
import { IsApplyDialogProvider } from '@core/utils/contexts/ApplyDialogContext/ApplDialogContext'
import { ModalProvider } from '@core/utils/contexts/ModalContext/ModalContextProvider'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'

import '@core/utils/i18n'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import '../../index.css'
import { CookiePage } from './CookiePage'
import theme from '../../theme.js'

const router = createBrowserRouter([
    {
        path: process.env.ENV === 'local' ? '' : '/cookie-notice',
        element: (
            <ThemeProvider>
                <IsApplyDialogProvider>
                    <CookiePage />
                </IsApplyDialogProvider>
            </ThemeProvider>
        ),
    },
])

const app = document.getElementById('root')
const root = createRoot(app!)
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <ModalProvider>
                    <RouterProvider router={router} />
                </ModalProvider>
            </ChakraProvider>
        </Provider>
    </>
)
